// src/context/AuthContext.jsx
import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);


export const AuthProvider = ({ children }) => {
  // In real life, hydrate from localStorage / cookie / backend
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null); // Remove if not used below

  // load from localStorage on first render
  useEffect(() => {
    const savedToken = localStorage.getItem("cb_token");
    const savedUser = localStorage.getItem("cb_user");
    if (savedToken && savedUser) {
      setToken(savedToken);
      setUser(JSON.parse(savedUser));
    }
  }, []);


  const login = async ({ email, password }) => {
    try {
      console.log('Running in environment:', process.env.NODE_ENV);
      const apiUrl = process.env.NODE_ENV === "production"
        ? "https://serenity.ing/login"
        : "http://localhost:4002/login";
        
      const res = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        return { ok: false, error: data.error || "Login failed" };
      }

      const data = await res.json();
      setToken(data.token);
      setUser(data.user);

      localStorage.setItem("cb_token", data.token);
      localStorage.setItem("cb_user", JSON.stringify(data.user));

      return { ok: true };
    } catch (err) {
      console.error("Login error", err);
      return { ok: false, error: "Network error" };
    }
  };

  const logout = () => {
    return new Promise((resolve) => {
      setToken(null);
      setUser(null);
      localStorage.removeItem("cb_token");
      localStorage.removeItem("cb_user");
      resolve();
    });
  }

  const value = {
    user,
    token,
    login,
    logout,
    isAuthenticated: !!token && !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
